<div #map id='map'></div>

<div #legendDiv id="legendDiv">
    <core-legend id='legend' #legend></core-legend>
</div>